import api from '../../../utils/api';
import qs from 'querystringify';
import { staticFilter, stringifyObjectProps } from '../../../utils/filterHelper';
import axios from 'axios';
import { escapeSpecialChars } from '../../../utils/textHelper';

let cancelGetUsers;
export const getUsers = (retailerId) => {
  if (cancelGetUsers) {
    cancelGetUsers('Cancel get users');
  }

  return api.get(`/retailers/${retailerId}/users`, {
    cancelToken: new api.CancelToken((c) => (cancelGetUsers = c)),
  });
};

let cancelGetRetailer;
export const getRetailer = (retailerId) => {
  if (cancelGetRetailer) {
    cancelGetRetailer('Cancel get retailer');
  }

  return api.get(`/retailers/${retailerId}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetRetailer = c)),
  });
};

export const getRetailerSuppliers = async (retailerId) => {
  return api.get(`/retailers/${retailerId}/suppliers`).catch((e) => {
    if (axios.isCancel(e)) {
      console.log(e, 'request canceled');
    }
  });
};

let cancelGetOrders;
export const getRetailerOrders = (retailerId, filter, perPage, offset, sort, field) => {
  if (cancelGetOrders) {
    cancelGetOrders(`Cancel retailer orders`);
  }

  const params = new URLSearchParams();
  params.append('filter', JSON.stringify(filter));
  params.append('limit', perPage);
  params.append('offset', offset);
  params.append('order', sort);
  params.append('sort', field);

  return api.get(`/retailers/${retailerId}/orders?${params}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetOrders = c)),
  });
};

let cancelGetOrderFilters;
export const getRetailerOrderFilters = (retailerId, filter) => {
  if (cancelGetOrderFilters) {
    cancelGetOrderFilters(`Cancel retailer orders`);
  }

  return api.get(`/retailers/${retailerId}/order-filters?filter=${JSON.stringify(filter)}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetOrderFilters = c)),
  });
};

let cancelGetOrder;
export const getRetailerOrder = (retailerId, orderId) => {
  if (cancelGetOrder) {
    cancelGetOrder(`Cancel retailer order #${orderId}`);
  }

  return api.get(`/retailers/${retailerId}/orders/${orderId}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetOrder = c)),
  });
};

let cancelGetRetailerStores;
export const getRetailerStores = (retailerId) => {
  if (cancelGetRetailerStores) {
    cancelGetRetailerStores('Cancel getRetailerStores');
  }

  const filter = JSON.stringify({ is_archived: false });

  return api.get(`/retailers/${retailerId}/stores?filter=${filter}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetRetailerStores = c)),
  });
};

let cancelGetProductFilters;
export const getProductFilters = (retailerId, supplierId, service) => {
  if (cancelGetProductFilters) {
    cancelGetProductFilters('Cancel get product-filters');
  }

  return api.get(`/retailers/${retailerId}/suppliers/${supplierId}/product-filters?service_type=${service}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetProductFilters = c)),
  });
};

let cancelGetProducts;
export const getProducts = (retailerId, supplierId, service, currentFilter, offset, perPage, search, order, field) => {
  if (cancelGetProducts) {
    cancelGetProducts('Cancel get products');
  }

  const filters = stringifyObjectProps(staticFilter(currentFilter));
  const url = `/retailers/${retailerId}/suppliers/${supplierId}/products`;
  const params = {
    service_type: service,
    properties_filter: filters.propertiesFilter,
    filter: filters.filter,
    offset,
    limit: perPage,
    q: escapeSpecialChars(search),
    order,
    sort: field,
  };

  return api.get(url + qs.stringify(params, true), {
    cancelToken: new api.CancelToken((c) => (cancelGetProducts = c)),
  });
};

let cancelGetProductsAll;
export const getProductsAll = (retailerId, supplierId, service, currentFilter, search) => {
  if (cancelGetProductsAll) {
    cancelGetProductsAll('Cancel products all');
  }

  const filters = stringifyObjectProps(staticFilter(currentFilter));
  const params = new URLSearchParams({
    service_type: service,
    filter: filters.filter,
    properties_filter: filters.propertiesFilter,
    q: escapeSpecialChars(search),
  });

  return api.get(`/retailers/${retailerId}/suppliers/${supplierId}/products-all?${params.toString()}`, {
    cancelToken: new api.CancelToken((c) => (cancelGetProductsAll = c)),
  });
};

let cancelDownloadReports;
export const downloadReports = (retailerId, data) => {
  if (cancelDownloadReports) {
    cancelDownloadReports('Cancel download report');
  }

  return api.post(`/retailers/${retailerId}/reports`, data, {
    cancelToken: new api.CancelToken((c) => (cancelDownloadReports = c)),
  });
};
